
// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './components/Landing/Landing';
import Search from './components/Search/Search';
import ProtectedRoute from './components/ProtectedRoute';
import AuthenticatedLayout from './components/AuthenticatedLayout';
import PrivacyPolicy from './components/Terms/PrivacyPolicy';
import TermsAndConditions from './components/Terms/TermsAndConditons';
import RefundPolicy from './components/Terms/RefundPolicy';
import Dashboard from './components/Dashboard/Dashboard';
import Inventory from './components/Inventory/Inventory';
import Sales from './components/Sales/Sales';
import Reports from './components/Reports/Reports';
import Notifications from './components/Notifications/Notifications'
import History from './components/History/History';
import Subscribe from './components/Search/Subscribe';
import VerifyEmailPage from './components/VerifyEmailPage';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Landing />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />

        {/* Protected Route */}
        <Route path="/search" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <Search />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <Dashboard />
            </AuthenticatedLayout>
          </ProtectedRoute>
        } />
         <Route
          path="/inventory"
          element={
            <ProtectedRoute>
              <AuthenticatedLayout>
                <Inventory />
              </AuthenticatedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales"
          element={
            <ProtectedRoute>
              <AuthenticatedLayout>
                <Sales />
              </AuthenticatedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/history"
          element={
            <ProtectedRoute>
              <AuthenticatedLayout>
                <History />
              </AuthenticatedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <AuthenticatedLayout>
                <Reports />
              </AuthenticatedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/alerts"
          element={
            <ProtectedRoute>
              <AuthenticatedLayout>
                <Notifications />
              </AuthenticatedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscribe"
          element={
            <ProtectedRoute>
              <AuthenticatedLayout>
                <Subscribe />
              </AuthenticatedLayout>
            </ProtectedRoute>
          }
        />
        <Route
        path="/verify"
        element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <VerifyEmailPage />
            </AuthenticatedLayout>
          </ProtectedRoute>
        }
      />
      </Routes>
    </Router>
  );
};

export default App;
